module.exports = __webpack_public_path__ + "img/envelope-open.6b63fd13.svg";